<template>
    <div class="carousel-sheet-container box-container">
        <!--<Icon icon="mdi:account-details" width="200" height="200"  color="#3d5afe"/>
        <p>Patient data of the selected patient (e.g. gathered from OnkoStar) would be shown here.</p>-->
        <div class="flex-cards">
            <!--Diagnosis card-->
            <div class="card default-shadow">
                <span class="card-headers">Diagnosis</span>
                <span v-for="item in diagnoses['3732979308']">
                    <p v-if="item.type == 'plaintext'">{{item.content}}<br></p>
                    <p v-if="item.type == 'plaintext-bold'"><b>{{item.content}}</b><br></p>
                    <ul v-if="item.type == 'list'">
                        <li v-for="list_item in item.content">{{list_item}}</li>
                    </ul>
                </span>
            </div>
            

            <!--Prev. therapy card-->
            <div class="card default-shadow">
                <span class="card-headers">Prev. Therapy</span>
                <span v-for="item in pretherapy['3732979308']">
                    <p v-if="item.type == 'plaintext'">{{item.content}}<br></p>
                    <ul v-if="item.type == 'list'">
                        <li v-for="list_item in item.content">{{list_item}}</li>
                    </ul>
                </span>
            </div>

            <!--Overall state-->
            <div class="card default-shadow">
                <span class="card-headers">Overall state</span>
                <span v-for="item in overall_state['3732979308']">
                    <p v-if="item.type == 'plaintext'">{{item.content}}<br></p>
                    <ul v-if="item.type == 'list'">
                        <li v-for="list_item in item.content">{{list_item}}</li>
                    </ul>
                </span>
            </div>

            <!--Side diags-->
            <div class="card default-shadow">
                <span class="card-headers">Side Diagnoses</span>
                <span v-for="item in side_diags['3732979308']">
                    <p v-if="item.type == 'plaintext'">{{item.content}}<br></p>
                    <ul v-if="item.type == 'list'">
                        <li v-for="list_item in item.content">{{list_item}}</li>
                    </ul>
                </span>
            </div>

        </div>
    </div>
</template>

<script setup lang="js">
import { useStore } from 'vuex';
import { Icon } from "@iconify/vue";
import { ref, computed } from 'vue';
const store = useStore();
const current_patient = computed(() => store.state.presentation_current_patient);

const diagnoses = ref({
    "3732979308": [
        {
            type: 'plaintext',
            content: 'Do not take these diagnoses seriously.'
        },
        {
            type: 'list',
            content: [
                'Main diagnosis: Adeno-Ca. of lung UL',
                'ICD-ID: C34.3',
                'Date of diagnosis: 06.05.2019',
                'Current status: Progress',
                'Metastases: brain'
            ]
        }
    ]
});

const pretherapy = ref({
    "3732979308": [
        {
            type: 'list',
            content: [
                '06/2019 – 08/2019 Cisgorkin/Retroxed/Blablubimab',
                '09/2019 – 02/2020 Blablubimab Erhaltung',
                '03/2020 – 05/2020 Something happened here',
                '08/2020 – 09/2020 Radiotherapy of primary tumor to 45 Gy',
                'Radiotherapy of brain metastasis to 30 Gy'
            ]
        },
        {
            type: 'plaintext-bold',
            content: 'Current recommendations:'
        },
        {
            type: 'list',
            content: [
                'New introduction of patient to MTB with skull MRT',
                'Image material already sent to colleagues in Italy',
                'A new appointment is already scheduled'
            ]
        }
    ]
});

const overall_state = ref({
    "3732979308": [
        {
            type: 'list',
            content: [
                'ECOG: 1',
            ]
        },
    ]
});

const side_diags = ref({
    "3732979308": [
        {
            type: 'list',
            content: [
                'No relevant side diagnoses',
            ]
        },
    ]
});

</script>

<style scoped>

.box-container {
    position: relative;
    overflow-y: scroll;
}

.flex-cards {
    width: 90%;
    position: absolute;
    top: 0;
    left: auto;
    margin-top: 32px;
    display: flex;
    flex-wrap: wrap;
    flex-basis: 100%;
    align-items: baseline;
    justify-items: stretch;
    row-gap: 20px;
}

.card {
    font-size: 1.1rem;
    padding: 16px;
    background-color: #f3f3f3;
    border: 2px solid #e3e3e3;
    border-radius: 5px;
    margin: 10px;
}

.card-headers {
    font-weight: 600;
    font-size: 1.2rem;
    text-decoration: underline;
}

</style>